export default {
  created() {
    const { pageName } = this.$route.meta;

    this.$store.commit('app/addPageName', pageName);
  },
};
